import { useCallback, useEffect, useState } from "react";
import { IoAdd, IoCheckmark, IoFileTrayOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";
import Toaster from "./../../../components/common/Toaster";
import chatService from "../../../services/chatService";

const AddMember = ({ room, isLoading, setIsLoading, onSuccess }) => {
  const [users, setUsers] = useState([]);

  const fetchUsers = useCallback(
    async (mounted) => {
      try {
        const { result } = await chatService.getAvailableUsersAsync(room.id);

        if (mounted) {
          const data = result.map((item) => {
            const container = { ...item };
            container["is_selected"] = false;

            return container;
          });

          setUsers(data);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
      }
    },
    [room]
  );

  const handleChange = (item) => {
    const data = [...users];
    const index = data.indexOf(item);

    data[index] = { ...data[index] };
    data[index].is_selected = !data[index].is_selected;

    setUsers(data);
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);

      const selected_users = users.filter((i) => i.is_selected);
      await chatService.assignUsersAsync(room.id, selected_users);

      setIsLoading(false);
      onSuccess();
      Toaster.Success("Users added successfully!");
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    }
  };

  useEffect(() => {
    let mounted = true;

    fetchUsers(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchUsers]);

  return (
    <form onSubmit={handleSubmit} className="p-8 space-y-1">
      {users.length === 0 && (
        <div className="flex justify-center p-5">
          <div className="text-center">
            <IoFileTrayOutline className="inline text-gray-300 text-3xl" />
            <p className="text-gray-400 text-sm mt-3">Nothing to show</p>
            <span className="text-xs text-gray-400">
              No available users at the moment.
            </span>
          </div>
        </div>
      )}
      {users.length > 0 &&
        users.map((item, index) => {
          return (
            <div
              key={index}
              onClick={() => handleChange(item)}
              className="card p-3 cursor-pointer hover:border-blue-400"
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-500">{item.name}</p>
                  <span className="text-xs text-gray-400">{item.role}</span>
                </div>
                {item.is_selected && (
                  <IoCheckmark className="text-green-500 text-xl" />
                )}
              </div>
            </div>
          );
        })}
      <div className="grid grid-2 pt-7">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={users.filter((i) => i.is_selected).length === 0}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoAdd className="mr-3" />}
            Add User
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddMember;
